import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";


export function getCaseDisputeItems(token, caseId, query) {
    const q = buildQuery(query);
    return axios.get(`${baseUrl}/case/${caseId}/dispute-items${q}`, {
        headers: {
            authorization: token
        }
    })
}

export function addNewDisputeItem (token, caseId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/dispute-item`, data, {
        headers: {
            authorization: token
        }
    })
}

export function getDisputeItemDetails (token, caseId, dIId) {
    return axios.get(`${baseUrl}/case/${caseId}/dispute-item-details/${dIId}`, {
        headers: {
            authorization: token
        }
    })
}

export function addDisputeItemDetails (token, caseId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/dispute-item-detail`, data, {
        headers: {
            authorization: token
        }
    })
}

export function confirmDispute (token, caseId, dIId) {
    return axios.patch(`${baseUrl}/case/${caseId}/dispute-item/${dIId}/confirm`, {}, {
        headers: {
            authorization: token
        }
    })
}